// extracted by mini-css-extract-plugin
export var bgColor = "middleNav-module--bgColor--c-KsB";
export var linkText = "middleNav-module--linkText--fjIAi";